import React, { useRef } from 'react';
import ModalOption from './ModalOption';

import Rupee from '../../../../Assets/Modals/Rupee.svg';
import Voucher from '../../../../Assets/Modals/Voucher.svg';
import Bundle from '../../../../Assets/Modals/Bundle.svg';
import VoucherReload from '../../../../Assets/Modals/VoucherReload.svg';
import Close from '../../../../Assets/Modals/closeIcon.svg';
import { useDispatch } from 'react-redux';
import { closeModal, setModalType } from '../../../../Features/dropTrackProductsSlice';
import { useOutsideClickHandler } from '../../../../Hooks/useOutsideClick';

function ModalMain() {
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => {
        dispatch(closeModal());
    });

    const handleButtonClick = () => {
        dispatch(closeModal());
    };

    const handleModalTypeSelection = (selection) => {
        dispatch(setModalType(selection));
    }

    return (
        <div ref={wrapperRef} className="w-1/2 h-fit bg-[#FFFFFF] rounded-xl p-6 flex flex-col gap-3">
            <div className="flex items-center justify-between">
                <h1 className='font-urbanist-regular font-semibold text-2xl text-[#121212]'>Launch Exclusive Action</h1>

                <button onClick={handleButtonClick}>
                    <img src={Close} alt="Close Modal" />
                </button>
            </div>

            {/* List */}
            <ModalOption 
                icon={Rupee} 
                handleSelection={handleModalTypeSelection} 
                id={'adjust-price'} 
                title={'Adjust Product Price'} 
                description={'Fine-tune your pricing strategy by adjusting the product price. This change will be reflected across Xenie, informing all DropTrack watchers of the new price point.'} 
            />
            <ModalOption 
                icon={Voucher} 
                handleSelection={handleModalTypeSelection} 
                id={'create-coupon'} 
                title={'Create New Coupon'} 
                description={'Energize sales with an exclusive coupon. Opt to target the broader Xenie shopper base or zero in on DropTrack watchers with a special offer they can\'t resist.'} 
            />
            <ModalOption 
                icon={Bundle} 
                handleSelection={handleModalTypeSelection} 
                id={'create-bundle-offer'} 
                title={'Create Bundle Offer'} 
                description={'Boost order value and clear inventory by pairing this product with complementary items in an irresistible bundle offer. Create bundles that appeal to shopper interests, encouraging more comprehensive purchases.'} 
            />
            <ModalOption 
                icon={VoucherReload} 
                handleSelection={handleModalTypeSelection} 
                id={'activate-coupon'} 
                title={'Reactivate Existing Coupons'} 
                description={'Reignite interest in your products by reactivating successful past coupons. Select from your coupon history to quickly bring back offers that previously captured shoppers\' hearts and wallets.'} 
            />
        </div>
    );
}

export default ModalMain;
